export default `
mutation updateMyEmail($input:updateMyEmailInput!) { 
    updateMyEmail(input:$input){ 
       user{
           email
       }
        }
    }
`;